import { get } from "lodash";

export const isFetching = (state, recordId) =>
  get(state, ["orders", "reports", "fetching", "byReportType", recordId]);

export const reports = state => state.orders.reports.report.byReportType;

export const report = (state, reportType) =>
  get(state, ["orders", "reports", "report", "byReportType", reportType], []);
